import { translate } from '../../../utils/translation'

export const useTranslation = () => ({
  dailyBalance: translate('Saldo do dia'),
})
